angular.module('impactx.company').controller('ClientCompanyNewsCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    'TranslationService',
    'ToolbarService',
    '$config',
    'TinyMceHelperService',
    ClientCompanyNewsCtrl]);

function ClientCompanyNewsCtrl($scope, dataGen, BackService, ToastService, TranslationService,
                               ToolbarService, $config, TinyMceHelperService) {
    var ctrl = this;

    dataGen.getData($scope, {}, "/company/clientcompany/news/view").then(function () {
        defineButtons();
    });

    this.save = function () {
        var dataObj = {
            newsData: $scope.data
        };

        return dataGen.postAsForm({}, dataObj, "/company/clientcompany/news/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    function defineButtons() {
        var buttonDefinition = $scope.data.newsMessage ? [
            {
                label: TranslationService.get("save"),
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ] : [];
        ToolbarService.setButtons(buttonDefinition);
    }

    $scope.tinymceOptions = TinyMceHelperService.getConfigurationWithUpload($config.tinymceOptions);
}